import { Loader2Icon } from 'lucide-react';
import type { JSX } from 'react';

import { CtLogo } from '@/components/brand/CtLogo.js';

/**
 * Full-viewport blocking overlay shown after the user accepts the
 * "update available" prompt. The refresh path tears down the service
 * worker and every cache and then reloads the app from the network,
 * which can take several seconds — during that window this overlay
 * covers the whole screen and swallows all pointer interaction so the
 * user isn't yanked mid-click by the reload. z-[100] sits above the
 * update toast portal (z-60) and Radix dialog overlays (z-50).
 */
export function UpdateInProgressOverlay(): JSX.Element {
  return (
    <div
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-6 bg-background px-6"
      role="alert"
      aria-busy="true"
    >
      <span className="grid size-14 shrink-0 place-items-center rounded-full bg-primary/12 text-primary">
        <CtLogo variant="mark" tone="mono" className="size-8" />
      </span>
      <div className="flex flex-col items-center gap-2 text-center">
        <p className="text-lg font-semibold text-foreground">
          Updating CT Agent
        </p>
        <p className="text-sm leading-relaxed text-muted-foreground">
          The latest version is loading. The app will reload automatically in a
          moment.
        </p>
      </div>
      <Loader2Icon
        className="size-6 animate-spin text-muted-foreground"
        aria-hidden
      />
    </div>
  );
}
